var map = {
	"./Cold-War.jpg": 66,
	"./Darkmagic.jpg": 67,
	"./OriginalGame.jpg": 68,
	"./The-Museum-Job.jpg": 69,
	"./acropolismys.jpg": 70,
	"./ayianapa3.jpg": 71,
	"./bunker.jpg": 72,
	"./christmas-site.jpg": 73,
	"./conjuring.jpg": 74,
	"./en_elm.jpg": 75,
	"./en_monalisa.jpg": 76,
	"./en_poirot.jpg": 77,
	"./en_tombraider.jpg": 78,
	"./esc2.jpg": 79,
	"./heist.jpg": 80,
	"./illuminati.jpg": 81,
	"./inception.jpg": 82,
	"./inspectorclouseau.jpg": 83,
	"./johnmonroeoffice.jpg": 84,
	"./kingstombs.jpg": 85,
	"./lab.jpg": 86,
	"./lost.jpg": 87,
	"./missingfinger.jpg": 88,
	"./mission.jpg": 89,
	"./museum1.jpg": 90,
	"./orientexp.jpg": 91,
	"./perfect-crime.jpg": 92,
	"./poker-night.jpg": 93,
	"./pope.jpg": 94,
	"./prison.jpg": 95,
	"./robcasino.jpg": 96,
	"./schidlers.jpg": 97,
	"./seven.jpg": 98,
	"./smugbay.jpg": 99,
	"./smugglersbay.jpg": 100,
	"./taken.jpg": 101,
	"./thelab.jpg": 102,
	"./tokeli.jpg": 103,
	"./unl_deathride.jpg": 104,
	"./unl_minionshunting.jpg": 105,
	"./wizzard.jpg": 106,
	"./zodiac_killer.jpg": 107,
	"./zombie_lab.jpg": 108
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;


//////////////////
// WEBPACK FOOTER
// ./src/rimages ^\.\/.*$
// module id = 17
// module chunks = 0